import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { validateCPF } from 'validations-br';

import { BankActions } from '@portal/actions';

import AdvancedInput from '@portal/components/AdvancedInput/AdvancedInput';
import ExternalContactForm, {
  ExternalFavoredFormProps,
} from '@portal/components/ExternalFavoredForm/ExternalFavoredForm';

import useReduxState from '@portal/hooks/useReduxState';
import { translate } from '@portal/services/i18n';
import { maskCpf } from '@portal/services/masks';

export interface SalaryPortabilityFavoredProps
  extends Omit<ExternalFavoredFormProps, 'banks'> {
  taxIdentifier: string;
  alias: string;
}

const SalaryPortabilityFavored = ({
  alias,
  bankAccount,
  setBankAccount,
  bankAccountDigit,
  setBankAccountDigit,
  bankAgency,
  setBankAgency,
  setBankCode,
  bankCode,
  bankUserName,
  setBankUserName,
  accountType,
  setAccountType,
  taxIdentifier,
  bankCodeType,
  pspList,
  setPspCode,
  pspCode,
}: SalaryPortabilityFavoredProps) => {
  const dispatch = useDispatch();

  const banks = useReduxState().bank.list;

  const getErrorMessage = (): string | undefined => {
    if (taxIdentifier.length < 11) {
      return;
    }

    const validateError = !validateCPF(taxIdentifier)
      ? translate(
          'COMPONENTS.CONTACT_LIST.NEW_CONTACT.MODAL.TAX_IDENTIFIER.PERSON'
        )
      : '';

    return validateError
      ? `${validateError} ${translate(
          'COMPONENTS.CONTACT_LIST.NEW_CONTACT.MODAL.TAX_IDENTIFIER.INVALID'
        )}`
      : undefined;
  };

  useEffect(() => {
    if (banks.length === 0) {
      dispatch(BankActions.getBanks());
    }
  }, [banks, dispatch]);

  return (
    <div className="salary-portability-favored">
      <AdvancedInput
        autoFocus
        variant="standard"
        label={translate('PAGES.MY_ACCOUNT.SALARY_PORTABILITY.FAVORED.FAVORED')}
        value={alias}
        readOnly
      />
      <AdvancedInput
        variant="standard"
        label={translate(
          'PAGES.MY_ACCOUNT.SALARY_PORTABILITY.FAVORED.TAX_IDENTIFIER.PERSON'
        )}
        value={maskCpf(taxIdentifier)}
        error={!!getErrorMessage()}
        helperText={getErrorMessage()}
        readOnly
      />
      <ExternalContactForm
        banks={banks}
        bankAccount={bankAccount}
        setBankAccount={setBankAccount}
        bankAccountDigit={bankAccountDigit}
        setBankAccountDigit={setBankAccountDigit}
        bankAgency={bankAgency}
        setBankAgency={setBankAgency}
        setBankCode={setBankCode}
        bankCode={bankCode}
        bankUserName={bankUserName}
        setBankUserName={setBankUserName}
        accountType={accountType}
        setAccountType={setAccountType}
        bankCodeType={bankCodeType}
        pspList={pspList}
        setPspCode={setPspCode}
        pspCode={pspCode}
      />
    </div>
  );
};

export default SalaryPortabilityFavored;
